export default "__VITE_ASSET__558a226d__"